import React from 'react';
import Layout from '../Components/Layout/Layout';
import EditAd from '../Components/Create/EditAd';

function EditAdPage() {
  return (
    <Layout>
      <EditAd />
    </Layout>
  );
}

export default EditAdPage;
